<template>
  <div class="deleted-info-mobile">
    <div class="deleted-info-mobile__image"></div>
    <div class="deleted-info-mobile__body _full">
      <p class="deleted-info-mobile__deleted-title">
        {{ titleText }}
      </p>
      <p class="deleted-info-mobile__deleted-name">
        <a
          class="deleted-info-mobile__deleted-name-link"
          target="_blank"
          :href="productLink"
        >
          {{ productName }}
        </a>
      </p>
      <button
        class="deleted-info-mobile__deleted-button"
        @click.prevent="handlerRestore"
      >
        {{ restoreText }}
      </button>
    </div>
    <button
      class="deleted-info-mobile__deleted-close-button"
      @click.prevent="handlerSplice"
    >
      <close16
        class="deleted-info-mobile__deleted-close-icon"
        :width="16"
        :height="16"
      />
    </button>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import useMovedOrDeletedInfo from '@/compositions/useMovedOrDeletedInfo';

import Close16 from '@/assets/sprite/svg/16/Close_16.svg';

export default defineComponent({
  name: 'MovedOrDeletedInfo',
  components: { Close16 },
  props: {
    productName: { type: String, default: '' },
    productLink: { type: String, default: '' },
    isMoved: { type: Boolean, default: false },
    isDeleted: { type: Boolean, default: false },
  },
  setup(props) {
    const movedOrDeletedInfo = useMovedOrDeletedInfo(props);
    return { ...movedOrDeletedInfo };
  },
});
</script>

<style lang="less">
.deleted-info-mobile {
  display: flex;
  align-items: stretch;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: @white;
  z-index: 1;
  padding: @size-x5 @size-x4;

  &__image {
    flex: 0 0 60px;
    margin-right: @size-x5;
    position: relative;
  }

  &__body {
    flex: auto;
    margin-right: @size-x4;
    display: flex;
    flex-direction: column;
  }

  &__deleted-title {
    .small();

    font-weight: bold;
    margin: 0;
    padding: 0;
  }

  &__deleted-name {
    .small();

    margin: 0 0 @size-x2;
    padding: 0;
  }

  &__deleted-name-link {
    .a-reset();

    color: currentColor;

    &:hover,
    &._tap {
      color: @link-hover;
    }
  }

  &__deleted-button {
    .button-reset();
    .small();

    color: @link;
    display: flex;

    &:hover,
    &._tap {
      color: @link-hover;
    }
  }

  &__deleted-close-button {
    .button-reset();

    position: absolute;
    right: @size-x4;
    top: @size-x6;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__deleted-close-icon {
    fill: @gray;
  }
}
</style>
